import PropTypes from 'prop-types';
import { useRef, createRef, useState } from 'react';

import { NOT_UPLOADED, PENDING_VERIFICATION, USER_ACTION_REQUIRED, VERIFIED } from '../../../utils/constants';

import Button from '../button/Button';
import FilePicker from '../inputs/file-picker/FilerPicker';
import Modal from '../modal/Modal';

import { ReactComponent as NotUploaded } from '../../../resources/icons/doc_rejected.svg';
import { ReactComponent as Accepted } from '../../../resources/icons/doc_accepted.svg';
import { ReactComponent as Trash } from '../../../resources/icons/trash.svg';
import { ReactComponent as Message } from '../../../resources/icons/message_notification.svg';
import { ReactComponent as Search } from '../../../resources/icons/search.svg';

import './verification-documents.scss';

const VerificationDocuments = ({
  verification,
  uploadVerificationDocument,
  deleteVerificationDocument,
  verificationType,
}) => {
  const refs = useRef([]);
  const [showModal, setShowModal] = useState(false);

  const getSymbol = (status) => {
    switch (status) {
      case PENDING_VERIFICATION:
        return (
          <div className="verification-documents__icon">
            <Search fill="orange" />
          </div>
        );
      case VERIFIED:
        return <Accepted />;
      default:
        return <NotUploaded />;
    }
  };

  if (!verification) {
    return undefined;
  }

  const documentRow = (subject, index) => {
    refs.current[index] = createRef();

    return (
      <section className="verification-documents__bank" key={index}>
        <div className="verification-documents__checkbox">
          <div className="verification-documents__box">{getSymbol(subject.status)}</div>
          <h2>{subject.subject}</h2>
        </div>

        {documents(subject.verificationDocumentStatuses)}
        <div className="verification-documents__button">
          <FilePicker
            fileRef={refs.current[index]}
            enableFileLimit={true}
            onChange={({ target }) => uploadVerificationDocument(target.files[0], subject.subject, verificationType)}
            triggerElement={
              <Button type="submit" onClick={() => refs.current[index].current.click()}>
                Add File
              </Button>
            }
          />
        </div>
      </section>
    );
  };

  const documents = (verificationDocumentStatuses) => {
    if (!verificationDocumentStatuses) return;
    return verificationDocumentStatuses?.map((document, index) => documentElement(document, index));
  };

  const documentElement = (document) => {
    return (
      <div className="verification-documents__document">
        {document.name && <p>{document.name}</p>}
        {document.status !== NOT_UPLOADED && !document.status && <p>No name Document</p>}
        {document.status && document.status !== NOT_UPLOADED && (
          <Trash
            fill="red"
            onClick={() => {
              deleteVerificationDocument(document.externalReference);
            }}
          />
        )}
        {document.status === USER_ACTION_REQUIRED && (
          <Message
            onClick={() => {
              setShowModal(true);
            }}
          />
        )}

        <Modal show={showModal} setShow={setShowModal}>
          <section className="account-management__rejection-modal">
            <section className="account-management__rejection-modal">
              <h2>Rejection Messages:</h2>
              {
                <div className="verification-documents__rejection">
                  {document.messages.map((message, index) => (
                    <div key={index}>
                      <p>{message.message}</p>
                    </div>
                  ))}
                </div>
              }
            </section>
          </section>
        </Modal>
      </div>
    );
  };

  return (
    <section className="verification-documents">
      <section className="verification-documents__heading">
        <h1>Please check the list for outstanding documents</h1>
      </section>
      {verification.documents?.map((subject, index) => documentRow(subject, index))}
    </section>
  );
};

VerificationDocuments.propTypes = {
  verification: PropTypes.shape({}),
  uploadVerificationDocument: PropTypes.func.isRequired,
  deleteVerificationDocument: PropTypes.func.isRequired,
  verificationType: PropTypes.string.isRequired,
};

VerificationDocuments.defaultProps = {
  verification: undefined,
};

export default VerificationDocuments;
